import Modal from "@/component/CustomModal";

interface MobileConfirmModalProps {
  visible: boolean;
  title: string;
  content?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const MobileConfirmModal = (props: MobileConfirmModalProps) => {
  const { visible, title, content, onConfirm, onCancel } = props;

  return (
    <Modal visible={visible} mask>
      <div className="bg-white w-80 pt-8 rounded-4 relative overflow-hidden">
        <div className="text-#333333 font-500 text-4.5 lh-4.5 text-center">
          {title}
        </div>
        {content && <div className="mt-4 text-#999999 text-3.75 h-5 lh-5 text-center">{content}</div>}

        <div className="mt-8 h-13 lh-13 text-center w-full flex items-center b-t-1px b-t-solid b-#000/10 text-4">
          <div
            className="h-full flex-1 text-#000000"
            onClick={onCancel}
          >
            取消
          </div>
          <div className="h-full w-1px bg-#ECEEF3"></div>
          <div className="h-full  flex-1 text-#FF4D4F hover:bg-#F4F6F9" onClick={onConfirm}>
            确定
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default MobileConfirmModal;
